var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2 } from '@angular/core';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { InvisibleReCaptchaComponent } from '../../../../node_modules/ngx-captcha';
import { NgForm } from '../../../../node_modules/@angular/forms';
var AuthUserOtpComponent = /** @class */ (function (_super) {
    __extends(AuthUserOtpComponent, _super);
    function AuthUserOtpComponent(renderer, modalService, authService) {
        var _this = _super.call(this, modalService, authService) || this;
        _this.renderer = renderer;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.data = {};
        _this.loginOriginAction = "";
        _this.showCaptcha = false;
        _this._countTimes = 0;
        _this._captchaResponse = null;
        _this._captchaReady = false;
        return _this;
    }
    AuthUserOtpComponent.prototype.ngOnInit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2130' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2130 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        this.data = this.modalService.data;
        this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
        sessionStorage.setItem("currentWindow", "סיסמה חד פעמית");
        sessionStorage.setItem("elasticCode", "2187");
        var element = this.renderer.selectRootElement('#pwOtp');
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
    };
    AuthUserOtpComponent.prototype.captchaSuccess = function (captchaResponse) {
        this._captchaResponse = captchaResponse;
        this.callServer();
    };
    AuthUserOtpComponent.prototype.captchaReady = function () {
        this._captchaReady = true;
    };
    AuthUserOtpComponent.prototype.submit = function (form) {
        this._form = form;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.serverError = null;
            this.pending = true;
            if (this._captchaReady) {
                this.captchaElem.execute();
            }
            else {
                this.callServer();
            }
        }
        this.buildFormAccessibility();
    };
    AuthUserOtpComponent.prototype.callServer = function () {
        var _this = this;
        this.authUserService.sendAuthData("ValidateOTP", { OTP: this._form.value.pwOtp, captchaResponse: this._captchaResponse })
            .subscribe(function (res) {
            if (res.Details.UserInputError == "OTPInvalid") {
                _this.serverError = "הסיסמה אינה נכונה";
                if (_this.captchaElem != null && _this.showCaptcha) {
                    _this.captchaElem.resetCaptcha();
                }
                _this.showCaptcha = res.Details.ShowOTPCaptcha == true;
                _this._countTimes++;
                console.log("Failure", res.Details);
            }
            else if (res.Details.UserInputError == "ReCaptchaInvalid") {
                _this.captchaElem.resetCaptcha();
                _this.serverError = "הקאפצ'ה נכשלה";
            }
            else {
                _this.modalService.close(res.Details);
            }
        }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
    };
    return AuthUserOtpComponent;
}(AuthBaseComponent));
export { AuthUserOtpComponent };
